exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Upbz{padding:13px 16px 15px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"tooltip-inner": "_3Upbz",
	"tooltipInner": "_3Upbz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/with-tooltip/with-tooltip.styl
// module id = 584
// module chunks = app-settings/app-settings dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page